export default __webpack_public_path__ + "static/media/icons8-checked-40 (2) 2.37381c12.svg";